/**
 * Detect if the current browser is WeChat browser
 * @returns {boolean} Returns true if in WeChat browser, otherwise false
 */
export const isWeChatBrowser = (): boolean => {
    const ua = navigator.userAgent.toLowerCase();
    // Check for WeChat browser identifier
    return /micromessenger/i.test(ua);
};

/**
 * Detect the operating system type
 * @returns {'ios' | 'android' | 'other'} The operating system type
 */
export const getOperatingSystem = (): 'ios' | 'android' | 'other' => {
    const ua = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/i.test(ua)) {
        return 'ios';
    }
    if (/android/i.test(ua)) {
        return 'android';
    }
    return 'other';
};

/**
 * Get the current page URL (for opening in browser)
 * @returns {string} The complete URL of the current page
 */
export const getCurrentPageUrl = (): string => {
    return window.location.href;
};

/**
 * Copy text to clipboard
 * @param text The text to copy
 * @returns {Promise<boolean>} Whether the copy was successful
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
    try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        } else {
            // Fallback: use traditional document.execCommand method
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.left = '-9999px';
            textArea.style.top = '-9999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            const successful = document.execCommand('copy');
            document.body.removeChild(textArea);
            return successful;
        }
    } catch (err) {
        console.error('Failed to copy text: ', err);
        return false;
    }
};
